import React from 'react';
import PropTypes from 'prop-types';
import { getURLParameters, map, mapValues } from '../../../../../lib/utilities';
import TranslationStore from '../../../stores/translations_store';
import getTranslatedText from '../../../helper/get_translated_text';
import Tooltip from '../../tooltip/tooltip';

const TranslationContainer = props => {
    const element = React.cloneElement(
        props.children,
        mapValues(
            props.targetProperties,
            ({ translationKey, placeholders }) =>
                props.transform(getTranslatedText(translationKey, placeholders || {})),
        )
    );

    const getParams = getURLParameters(location.search);

    //TODO: verify implementation
    return getParams.show_translation_keys === '1'
        ? (
            <Tooltip
                content={
                    map(
                        props.targetProperties,
                        ({ translationKey }) => translationKey,
                    ).join('<br>')
                }
                additionalClassNames={['tooltip--no-style']}
            >
                {element}
            </Tooltip>
        )
        : element;
};

TranslationContainer.propTypes = {
    targetProperties: PropTypes.objectOf(
        PropTypes.shape({
            translationKey: PropTypes.string.isRequired,
            placeholders: PropTypes.object,
        })
    ).isRequired,
    transform: PropTypes.func,
};

TranslationContainer.defaultProps = {
    transform: input => input,
};

export default TranslationContainer;
